import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"

import { CardTitle, PieChartCard } from "../Factsheet.styled"

interface DistributionPieProps {
  title: string
  data: { name: string; value: number }[]
}

const DistributionPie = ({ title, data }: DistributionPieProps) => {
  const options: Highcharts.Options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 200,
    },
    title: {
      text: undefined,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        innerSize: "50%",
      },
    },
    legend: {
      align: "right",
      verticalAlign: "middle",
      layout: "vertical",
      width: 120,
      itemStyle: {
        color: "#a0a0a0",
        fontSize: "11px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        width: 110,
      },
      itemHoverStyle: {
        color: "#ffffff",
      },
    },
    series: [
      {
        type: "pie",
        name: "Allocation",
        data: data.slice(0, 6).map(item => ({
          name: item.name,
          y: item.value,
        })),
      },
    ],
    tooltip: {
      pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
  }

  return (
    <PieChartCard flexDirection="column">
      <CardTitle>{title}</CardTitle>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </PieChartCard>
  )
}

export default DistributionPie
